// import Swiper JS
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
// import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

document.addEventListener("readystatechange", (e) => {
	if (document.readyState === "complete") {
		const addCSSclasses = (el, ...cls) =>
			cls.map((cl) => el.classList.add(cl));

		const removeCSSclasses = (el, ...cls) =>
			cls.map((cl) => el.classList.remove(cl));

		// If no-js is on the html tag, replace it
		let noJs = document.querySelector(".no-js");
		if (noJs) {
			addCSSclasses(noJs, "js");
			removeCSSclasses(noJs, "no-js");
		}

		// Header scroll effect
		const header = document.querySelector(".header");

		// Apply lazy-loading to images below the fold
		const applyLazyLoading = () => {
			const imgs = Array.from(document.querySelectorAll("img"));
			imgs.forEach((img, i) => {
				// Respect explicit eagerness
				if (img.hasAttribute("loading")) return;
				if (img.dataset.eager === "true") return;
				const rect = img.getBoundingClientRect();
				// Skip top-of-page images (first two imgs and those initially in view)
				const isInitiallyInView =
					rect.top <
					(window.innerHeight ||
						document.documentElement.clientHeight);
				if (i < 2 || isInitiallyInView) return;
				img.setAttribute("loading", "lazy");
				img.setAttribute("decoding", "async");
			});
		};
		// Run once on load and again after a tick (in case of late layout)
		applyLazyLoading();
		setTimeout(applyLazyLoading, 150);

		// Scroll reveal (AOS-like) using IntersectionObserver
		const reveals = new Set();
		const revealObserver = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add("is-visible");
						obs.unobserve(entry.target);
					}
				});
			},
			{ root: null, rootMargin: "0px", threshold: 0.15 }
		);

		const observeReveals = (nodes) => {
			if (!nodes) return;
			(nodes instanceof NodeList || Array.isArray(nodes)
				? nodes
				: [nodes]
			).forEach((node) => {
				if (node && !reveals.has(node)) {
					reveals.add(node);
					revealObserver.observe(node);
				}
			});
		};

		// Reset and re-arm reveals so they animate again
		const rearmReveals = (nodes) => {
			if (!nodes) return;
			const list =
				nodes instanceof NodeList || Array.isArray(nodes)
					? nodes
					: [nodes];
			list.forEach((node) => {
				node.classList.remove("is-visible");
				// Remove from the tracking set so it can be observed again
				if (reveals.has(node)) reveals.delete(node);
				// Force reflow so CSS transitions restart cleanly
				void node.offsetHeight; // eslint-disable-line no-unused-expressions
			});
			observeReveals(list);
		};

		// Observe any pre-tagged elements
		observeReveals(document.querySelectorAll("[data-reveal], .reveal"));

		// Auto-tag and observe Swiper slides for subtle entrance
		const tagAndObserve = (
			selector,
			baseDelay = 0,
			step = 0.07,
			variant = "reveal--up"
		) => {
			const nodes = document.querySelectorAll(selector);
			nodes.forEach((node, i) => {
				node.classList.add("reveal", variant);
				node.style.setProperty(
					"--reveal-delay",
					`${(baseDelay + i * step).toFixed(2)}s`
				);
			});
			observeReveals(nodes);
		};

		// Slides in services and testimonials (animate slides and their immediate children)
		tagAndObserve(".swiper-services .swiper-slide");
		tagAndObserve(
			".swiper-services .swiper-slide > *",
			0,
			0.06,
			"reveal--up"
		);
		// Intentionally skip testimonials to keep them static

		// Apply reveals uniformly to all section containers EXCEPT testimonials to avoid mixed siblings
		tagAndObserve(
			"section:not(#testimonials) .container > *",
			0,
			0.05,
			"reveal--up"
		);
		// Mobile menu content items (for consistency)
		tagAndObserve(".mobile-menu__content > *", 0, 0.04, "reveal--up");
		// Footer benefit grid items
		tagAndObserve("footer .grid > *", 0, 0.05, "reveal--up");

		// Cleanup: remove any reveal classes that may have been previously applied in testimonials
		const testimonialReveals = document.querySelectorAll(
			"#testimonials .reveal, #testimonials [data-reveal]"
		);
		testimonialReveals.forEach((el) => {
			el.classList.remove(
				"reveal",
				"reveal--up",
				"reveal--down",
				"reveal--left",
				"reveal--right",
				"reveal--zoom",
				"is-visible"
			);
			el.removeAttribute("data-reveal");
		});

		// Dynamic anchor offset based on header height
		const setAnchorOffset = () => {
			if (!header) return;
			const offset = header.offsetHeight; // small extra breathing room
			document.querySelectorAll("[id]").forEach((el) => {
				el.style.scrollMarginTop = `${offset}px`;
			});
		};

		// Initialize offset and keep it in sync with layout changes
		setAnchorOffset();
		window.addEventListener("resize", setAnchorOffset);

		window.addEventListener("scroll", () => {
			if (!header) return;
			if (window.scrollY > 50) {
				header.classList.add("scrolled");
			} else {
				header.classList.remove("scrolled");
			}
			// Update anchor offsets when header height may change due to scrolled state
			setAnchorOffset();
		});

		//? mobile menu
		const mobileMenuItems = document.querySelectorAll(".mobile-menu__item");
		const mobileMenuClose = document.querySelectorAll("#burger_close");
		const mobileMenu = document.querySelector(".mobile-menu");
		const mobileMenuOverlay = document.querySelector(
			".mobile-menu__overlay"
		);
		const burgerBtnOpen = document.getElementById("burger_open");
		const burgerBtnClose = document.getElementById("burger_close");

		function closeMobileNav(e) {
			if (e) e.preventDefault();
			if (!mobileMenu) return;
			// Start slide-out
			mobileMenu.classList.remove("open");
			// After transition, hide container to restore DOM state
			const finishHide = () => {
				mobileMenu.classList.add("hidden");
				mobileMenu.removeEventListener("transitionend", finishHide);
			};
			mobileMenu.addEventListener("transitionend", finishHide);
			// Fallback in case transitionend doesn't fire
			setTimeout(finishHide, 350);
			document.body.style.overflow = "auto";
		}
		function openMobileNav(e) {
			if (e) e.preventDefault();
			if (!mobileMenu) return;
			// Re-arm mobile menu reveals so they animate on every open
			rearmReveals(
				document.querySelectorAll(".mobile-menu__content > *")
			);
			// Reveal container first, then trigger transform in next frame
			mobileMenu.classList.remove("hidden");
			requestAnimationFrame(() => {
				mobileMenu.classList.add("open");
			});
			document.body.style.overflow = "hidden";
		}

		// submenu toggle
		if (mobileMenuItems) {
			mobileMenuItems.forEach((item) => {
				const link = item.querySelector(".mobile-menu__link");
				const backBtn = item.querySelector(".mobile-menu__back-button");

				// console.log("link", link);
				if (
					link.getAttribute("href") &&
					link.getAttribute("href") === "#"
				) {
					link.addEventListener("click", (e) => {
						e.preventDefault();
						link.nextElementSibling.classList.toggle("hidden");
					});
				}
				if (backBtn) {
					backBtn.addEventListener("click", (e) => {
						e.preventDefault();
						link.nextElementSibling.classList.toggle("hidden");
					});
				}
			});
		}

		if (mobileMenuClose) {
			mobileMenuClose.forEach((close) => {
				close.addEventListener("click", (e) => {
					closeMobileNav(e);
				});
			});
		}
		if (mobileMenuOverlay) {
			mobileMenuOverlay.addEventListener("click", (e) => {
				closeMobileNav(e);
			});
		}

		if (burgerBtnOpen) {
			burgerBtnOpen.addEventListener("click", (e) => {
				openMobileNav(e);
			});
		}
		if (burgerBtnClose) {
			burgerBtnClose.addEventListener("click", (e) => {
				closeMobileNav(e);
			});
		}

		// Close mobile menu on link click (but not submenu toggles with href="#")
		const mobileMenuNavigatingLinks = document.querySelectorAll(
			'.mobile-menu a[href]:not([href="#"])'
		);
		if (mobileMenuNavigatingLinks && mobileMenuNavigatingLinks.length) {
			mobileMenuNavigatingLinks.forEach((link) => {
				link.addEventListener("click", () => {
					// Do NOT prevent default; allow navigation/anchor jump, but animate close
					closeMobileNav();
				});
			});
		}

		//? swiper
		var swiper = new Swiper(".swiper-services", {
			modules: [Navigation, Pagination],
			lazy: true,
			loop: true,
			spaceBetween: 30,
			autoplay: {
				delay: 2500,
				disableOnInteraction: true,
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		});
		var testimonialsSwiper = new Swiper(".swiper-testimonials", {
			modules: [Navigation, Pagination],
			loop: true,
			spaceBetween: 30,
			autoplay: {
				delay: 2500,
				disableOnInteraction: true,
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		});

		//? Gallery functionality
		const galleryImages = [
			{
				src: "/assets/static/images/gallery/closeboard-fencing3.webp",
				alt: "Closeboard Fencing Installation",
				height: 500,
			},
			{
				src: "/assets/static/images/gallery/acoustic-fencing.webp",
				alt: "Metal Security Fencing",
				height: 300,
			},
			{
				src: "/assets/static/images/gallery/artificial-grass.webp",
				alt: "Artificial Grass Installation",
				height: 300,
			},
			{
				src: "/assets/static/images/gallery/gate.webp",
				alt: "Gate Installation",
				height: 500,
			},
			{
				src: "/assets/static/images/gallery/palisade-fencing1.webp",
				alt: "Palisade Fencing Installation",
				height: 500,
			},
			{
				src: "/assets/static/images/gallery/closeboard-fencing1.webp",
				alt: "Closeboard Fencing Installation",
				height: 300,
			},
			{
				src: "/assets/static/images/gallery/palisade-fencing4.webp",
				alt: "Palisade Fencing Installation",
				height: 500,
			},
			{
				src: "/assets/static/images/gallery/closeboard-fencing2.webp",
				alt: "Closeboard Fencing Installation",
				height: 300,
			},
			{
				src: "/assets/static/images/gallery/hoarding1.webp",
				alt: "Hoarding Installation",
				height: 300,
			},
			{
				src: "/assets/static/images/gallery/hoarding2.webp",
				alt: "Hoarding Installation",
				height: 300,
			},
			{
				src: "/assets/static/images/gallery/palisade-fencing2.webp",
				alt: "Palisade Fencing Installation",
				height: 300,
			},
			{
				src: "/assets/static/images/gallery/palisade-fencing3.webp",
				alt: "Palisade Fencing Installation",
				height: 300,
			},
			{
				src: "/assets/static/images/gallery/tree-protection-fencing2.webp",
				alt: "Tree Protection Installation",
				height: 300,
			},
			{
				src: "/assets/static/images/gallery/tree-protection-fencing3.webp",
				alt: "Tree Protection Installation",
				height: 500,
			},
			{
				src: "/assets/static/images/gallery/tree-protection-fencing1.webp",
				alt: "Tree Protection Installation",
				height: 500,
			},
		];

		let currentImageIndex = 0;
		const imagesPerLoad = 6;
		let allLoadedImages = []; // Keep track of all loaded images for lightbox

		function createGalleryItem(image, index) {
			const globalIndex = allLoadedImages.length; // Get the current total count
			allLoadedImages.push(image.src); // Add to our lightbox array

			const delay = (index % imagesPerLoad) * 0.1;
			return `
				<div class="gallery-item reveal reveal--zoom" onclick="openLightbox(${globalIndex})" style="--reveal-delay: ${delay}s">
					<img loading="lazy" decoding="async" src="${image.src}" alt="${image.alt}">
					<div class="zoom-icon"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
  <circle cx="12.2988" cy="12.3779" r="10.5" stroke="#ED7F22" stroke-width="2"/>
  <path d="M12.2988 8.24585V16.5098" stroke="#ED7F22" stroke-width="2" stroke-linecap="round"/>
  <path d="M16.4308 12.3779H8.16687" stroke="#ED7F22" stroke-width="2" stroke-linecap="round"/>
  <path d="M26.5759 28.1047C26.9664 28.4953 27.5996 28.4953 27.9901 28.1047C28.3806 27.7142 28.3806 27.081 27.9901 26.6905L27.283 27.3976L26.5759 28.1047ZM27.283 27.3976L27.9901 26.6905L20.4799 19.1803L19.7728 19.8874L19.0657 20.5945L26.5759 28.1047L27.283 27.3976Z" fill="#ED7F22"/>
</svg></div>
				</div>
			`;
		}

		function loadImages() {
			const galleryGrid = document.getElementById("galleryGrid");
			const loadMoreBtn = document.getElementById("loadMoreBtn");

			// Check if elements exist (only run on gallery page)
			if (!galleryGrid || !loadMoreBtn) return;

			const endIndex = Math.min(
				currentImageIndex + imagesPerLoad,
				galleryImages.length
			);

			for (let i = currentImageIndex; i < endIndex; i++) {
				galleryGrid.innerHTML += createGalleryItem(galleryImages[i], i);
			}

			currentImageIndex = endIndex;

			// Hide load more button if all images are loaded
			if (currentImageIndex >= galleryImages.length) {
				loadMoreBtn.style.display = "none";
			}
		}

		// Make openLightbox function globally accessible
		window.openLightbox = function (index) {
			// FSLightbox implementation
			if (
				typeof fsLightboxInstances !== "undefined" &&
				fsLightboxInstances["gallery"]
			) {
				fsLightboxInstances["gallery"].open(index);
			}
		};

		// Initialize FSLightbox
		function initializeFSLightbox() {
			// Wait for FSLightbox to be available
			if (typeof fsLightboxInstances !== "undefined") {
				fsLightboxInstances["gallery"] = new FsLightbox();
				fsLightboxInstances["gallery"].props.sources = allLoadedImages;
				fsLightboxInstances["gallery"].props.type = "image";
			} else {
				// Try again in a moment if FSLightbox isn't ready yet
				setTimeout(initializeFSLightbox, 100);
			}
		}

		// Gallery initialization - only run if gallery elements exist
		const galleryGrid = document.getElementById("galleryGrid");
		const loadMoreBtn = document.getElementById("loadMoreBtn");

		if (galleryGrid && loadMoreBtn) {
			// Load initial images
			loadImages();

			// Add event listener for load more button
			loadMoreBtn.addEventListener("click", function () {
				loadImages();
				// Update FSLightbox sources after loading new images
				if (
					typeof fsLightboxInstances !== "undefined" &&
					fsLightboxInstances["gallery"]
				) {
					fsLightboxInstances["gallery"].props.sources =
						allLoadedImages;
				}
			});

			// Initialize lightbox with a small delay
			setTimeout(initializeFSLightbox, 200);
		}
	}
	// Code above this brace
});
